<template>
  <div class="container-fluid">
    <div class="col-12 my-col col-xl col-lg-12 col-sm-12 ">
      <center><h3>Costs and usage overview Shared CSS User Pack</h3></center>
      <tls product='Shared Services'/>
      <newRelic :accountId='2663295'> </newRelic>
    </div>
  </div>
</template>
<script>

import newRelic from '@/pages/newrelic.vue'
import tls from '@/pages/teams/components/tls.vue'
export default {
  components: {
    newRelic,
    tls,
  },
}
</script>
